import { Observable, BehaviorSubject } from 'rxjs';

export class ExperienceService {
    private experienceState$: BehaviorSubject<any>;

    constructor() {}

    getValue(): any {
        return this.experienceState$.getValue();
    }

    getState(): Observable<any> {
        return this.experienceState$.asObservable();
    }

    public getCelineVersion(routerLink: string): Number {
        let findVersion = parseInt(this.getValue()
            .filter((experience) => {
                // find experience which contains routerlink
                return (routerLink.includes(experience.name));            
            })
            .map(function (experience) {
                // grab celineVersion
                return experience.celineVersion ? experience.celineVersion : 1
            }).toString());

        if (isNaN(findVersion)) {
            return null;
        } else
        {
            return findVersion;
        }
    }


    setInitialState(initialState: any) {
        let formatted = [];
        initialState.map((experience: any) => {
            let celineVersion: number;
            if (experience.tags) celineVersion = experience.tags.celineVersion ? experience.tags.celineVersion : 1; 
            else celineVersion = 1;

            formatted.push({ 'name': experience.path, 'celineVersion': celineVersion });
        });
        this.experienceState$ = new BehaviorSubject(formatted);    
    }

    setState(nextState: any): void {
        this.experienceState$.next(nextState);
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/experience.service.ts